(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["botanical-library-entry"]) return;
  try {
    
function initLibraryEntry(root){if(root.dataset.ready)return;root.dataset.ready='true';const headings=[...root.querySelectorAll('.ble-body h2, .ble-content section h2')];if(headings.length<2)return;const nav=root.querySelector('.ble-toc nav');headings.forEach((heading,index)=>{heading.id=heading.id||'library-section-'+index;const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;nav.append(link);});root.querySelector('.ble-toc').hidden=false;}
document.querySelectorAll('[data-library-entry]').forEach(initLibraryEntry);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-library-entry]').forEach(initLibraryEntry));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["botanical-library-index"] && !Shopify.designMode) return;
  try {
    
function initLibraryIndex(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const rows=[...root.querySelectorAll('[data-library-row]')];const list=root.querySelector('[data-library-list]');
 rows.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title)).forEach(row=>list.append(row));
 const input=root.querySelector('[data-library-search]');const status=root.querySelector('[data-library-status]');let category='',letter='';
 const normalize=text=>text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
 function update(){const terms=normalize(input.value.trim()).split(/\s+/).filter(Boolean);let count=0;for(const row of rows){const matches=(!category||(row.dataset.categories||'').split('|').includes(category))&&(!letter||row.dataset.title.toUpperCase().startsWith(letter))&&terms.every(term=>normalize(row.dataset.search).includes(term));row.hidden=!matches;if(matches)count++;}status.textContent=count+' '+(count===1?status.dataset.singular:status.dataset.plural);root.querySelector('[data-library-empty]').hidden=count!==0;root.querySelectorAll('[data-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.category===category)));root.querySelectorAll('[data-letter]').forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.letter===letter));button.disabled=!rows.some(row=>(!category||(row.dataset.categories||'').split('|').includes(category))&&row.dataset.title.toUpperCase().startsWith(button.dataset.letter));});}
 root.querySelector('.bl-controls').hidden=false;input.addEventListener('input',()=>{letter='';update();});root.querySelector('[data-library-clear]').addEventListener('click',()=>{input.value='';update();input.focus();});root.querySelector('[data-library-reset]').addEventListener('click',()=>{input.value='';category='';letter='';update();});root.querySelectorAll('[data-category]').forEach(button=>button.addEventListener('click',()=>{category=button.dataset.category;letter='';update();}));root.querySelectorAll('[data-letter]').forEach(button=>button.addEventListener('click',()=>{letter=letter===button.dataset.letter?'':button.dataset.letter;update();}));update();
}
document.querySelectorAll('[data-library-index]').forEach(initLibraryIndex);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-library-index]').forEach(initLibraryIndex));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
